import React from "react";
import Link from "next/link";
import useAxios from "axios-hooks";
import { WEB_API } from "../../constants";

const AllCategories = ({ data }) => {
  return (
    <div className="categories-area ptb-100">
      <div className="container">
        <div className="section-title">
          <span className="sub-title">Categories</span>
          <h2>All Categories</h2>
          <p>
            At ToppersNotes, Get the latest edition of all the books and
            packages properly indexed and segmented as per the requirements of
            all the aspirants of National and State Level Exams
          </p>
        </div>

        <div className="row">
          {data
            ? data.map((category) => (
                <div className="col-lg-3 col-sm-6 col-md-6">
                  <div className="single-categories-box">
                    <img
                      style={{ width: "100%" }}
                      src={category.img}
                      className=" h-48"
                      alt="image"
                    />

                    <div className="content">
                      <h3>{category.name}</h3>
                    </div>

                    <Link href={`/categories/${category.slug}`}>
                      <a className="link-btn"></a>
                    </Link>
                  </div>
                </div>
              ))
            : "Loading"}
        </div>
      </div>
    </div>
  );
};

export default AllCategories;
